import styled from "styled-components";
import {Layout} from "antd";
import {Header} from "antd/lib/layout/layout";
import {Content} from "antd/es/layout/layout";

export const StyledPanel = styled(Layout)`
  min-height: 100vh;
  flex-direction: row;
`;

export const StyledPanelWrapper = styled(Layout)`
  min-height: 100vh;
  flex-direction: row;
`;

export const StyledLogoEmpty = styled.div`
  height: 32px;
  margin: 16px;
  background-color: #ffffff4d;
`;

export const StyledPanelHeader = styled(Header)`
  background-color: #ffffff;
`;

export const StyledPanelContent = styled(Content)`
  background-color: #ffffff;
  min-height: 280px;
  margin: 24px 16px;
  padding: 24px;
`;

export const StyledPanelLoader = styled.div`
  background-color: #ffffff;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
